<button class="default-button" :class="buttonClasses" v-bind="$attrs"><slot></slot></button>